module.exports = __webpack_public_path__ + "images/stickers/taco-clean.e6462e51e766dbf494e3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-clean.png
// module id = Cbfv
// module chunks = 0